<script>
  import {createEventDispatcher} from 'svelte';
  const dispatch = createEventDispatcher();
  export let app;
  const dateOptions = {month: 'long', day: 'numeric', hour: "numeric", minute: "numeric"};
  const elementAction = (tag) => {
    if(tag === 'close') return dispatch('elementAction', {tag});
  }

  const getEntries = async() => {
    const res = await fetch(`/api/v1/integrity-checks/${app._id}`);
    return await res.json();
  }
 
</script>

{#await getEntries()} 
  <!-- fetching devices -->
{:then entries}
 
  <div class="block">
  {#if (entries.length == 0)}
      No entries.
  {:else}
    Listing {entries.length} most recent entries. Max 100.
  {/if}
  </div>
  {#each entries as entry (entry._id) }
    <div class="table-container">
      <table class="mb-2 table is-bordered is-striped is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>Alert Type</th>
            <th>Received At</th>
            <th>Checked At</th>
            <th>Device</th>
            <th>Device Eui</th>
            <th>Battery Voltage</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{entry.checkType}</td>
            <td>{new Date(entry.receivedAt).toLocaleString('no-NO', dateOptions)}</td>
            <td>{new Date(entry.checkedAt).toLocaleString('no-NO', dateOptions)}</td>
            <td>{entry.deviceTitle}</td>
            <td>{entry.deviceEui}</td>
            <td>{entry.batteryVoltage || ''}</td>
          </tr>
        </tbody>
      </table>
    </div>
  {/each}
{:catch error}
  <p>{error}</p>
{/await}

<div class="block">
  <i>Treshold for date/time is 24 hours.</i>
  <i>Treshold for battery voltages is 4.9 V</i>
</div>
<div class="field is-grouped">
  <p class="control">
    <button class="button is-info" type="button" on:click={() => elementAction('close')}>Close</button>
  </p>
</div>